module.exports = __webpack_public_path__ + "img/face-raised-eyebrow.d478ca90.svg";